export default __webpack_public_path__ + "static/webRotator/svg/bbbf9680f3a8f996ea80274fe54518cc.svg";